import "../css/CommonDesign.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Stepper, Step, StepLabel, Container, Stack, Divider, Button, InputLabel, TextField, Breadcrumbs, Typography, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from "axios";
import { API } from "./constantsFront";
import MenuMenu from "./MenuMenu";

const steps = [
  '情報入力',
  '内容の確認',
  '完了',
];

const D0042ContactConfirm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const contacts = location.state.dataList[0];
  //     productName:number
  //   , countryName
  //   , contactDetail
  //   , companyName
  //   , corpoNum
  //   , director
  //   , nameKanji
  //   , nameKana
  //   , mailAddress
  //   , phoneNumber
  //   , noShare
  //   , isConsent
  // };

  // 住所
  // var address1 = '';
  // if (contacts[5] != '') {
  //   const zenhan = contacts[5].substr(0, 3);
  //   const kouhan = contacts[5].substr(3, 4);
  //   address1 = '〒' + zenhan + '-' + kouhan + '  ';
  // }

  // const address = address1 + contacts[6] + contacts[7];

  // プライバシーポリシー
  // var personalInfo = '';
  // if (contacts.isConsent == true) {
  //   personalInfo = '同意する';
  // } else {
  //   personalInfo = '同意しない'; // ここに来ることは現状無い
  // }

  let body = { authKey: API.API_KEY };

  // 入力データを保持する
  // const contactList = [];
  // for (let i in contacts) {
  //   contactList.push(contacts[i]);
  // }

  // 送信ボタン
  async function sendContact() {
    try {
      console.log("送信処理開始");

      // POST用データ作成
      // let obj = {
      //   sendFullNameKanji: contacts[0],
      //   sendFullNameKana: contacts[1],
      //   sendCompanyName: contacts[2],
      //   sendPhoneNumber: contacts[3],
      //   sendMailAddress: contacts[4],
      //   sendAddress1: contacts[5],
      //   sendAddress2: contacts[6],
      //   sendAddress3: contacts[7],
      //   sendSex: contacts[8],
      //   sendAge: contacts[9],
      //   sendContactDetail: contacts[10],
      // };
      let objStr = JSON.stringify(contacts);
      body.objStr = objStr;

      const send = await axios.post("/D0042/mailsend", body);
      if (send.status === 200) {
        console.log("送信成功");
      } else {
        console.log("送信失敗");
      }

      console.log("送信処理終了");
      return navigate("/D0043ContactComplete");
    } catch (e) {
      console.log("例外が発生しました");
      console.log(e.message);
    }
  }

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      お問合せ
                    </Typography>,
                    {/* <Typography key="3" color="text.primary">
                      お問い合わせ　内容確認
                    </Typography> */}
                  </Breadcrumbs>

                  <h1>お問合せ</h1>

                  <Stepper activeStep={1} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>

                  <div>
                    以下の内容で送信します。よろしければ「送信」ボタンをクリックしてください。
                  </div>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>輸出品目名</InputLabel>
                    <InputLabel>{contacts.productName}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>輸出先国名</InputLabel>
                    <InputLabel>{contacts.countryName}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>相談内容</InputLabel>
                    <TextField multiline rows={5}
                      inputProps={{ readOnly: true }}
                      style={{ width: "100%", marginTop: '10px' }}
                      value={contacts.contactDetail} />
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>企業名</InputLabel>
                    <InputLabel>{contacts.companyName}</InputLabel>
                  </Stack>
                  <Divider />
                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>法人番号</InputLabel>
                    <InputLabel>{contacts.corpoNum}</InputLabel>
                  </Stack>
                  <Divider />
                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>役職</InputLabel>
                    <InputLabel>{contacts.director}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>
                      氏名（漢字）</InputLabel>
                    <InputLabel>{contacts.nameKanji}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>氏名（かな）</InputLabel>
                    <InputLabel>{contacts.nameKana}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>メールアドレス</InputLabel>
                    <InputLabel>{contacts.mailAddress}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>電話番号</InputLabel>
                    <InputLabel>{contacts.phoneNumber}</InputLabel>
                  </Stack>
                  <Divider />


                  {/* <Stack spacing={32} direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel>住所</InputLabel>
                    <InputLabel>{address}</InputLabel>
                  </Stack>
                  <Divider /> */}

                  {/* <Stack spacing={32} direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel>性別</InputLabel>
                    <InputLabel>{contacts[8]}</InputLabel>
                  </Stack>
                  <Divider /> */}

                  {/* <Stack spacing={32} direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel>年代</InputLabel>
                    <InputLabel>{contacts[9]}</InputLabel>
                  </Stack>
                  <Divider /> */}

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>相談内容の取扱いについて</InputLabel>
                    <InputLabel>{contacts.noShare ? "共有を承諾しない" : "共有を承諾する"}</InputLabel>
                  </Stack>
                  <Divider />

                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <InputLabel style={{ minWidth: "30%", maxWidth: "100%" }}>個人情報の取扱いについて</InputLabel>
                    <InputLabel>{contacts.isConsent ? "同意する" : "同意しない"}</InputLabel>
                  </Stack>
                  <Divider />

                  <div
                    style={{
                      display: "flex"
                      , justifyContent: "center"
                      , position: "relative"
                      , flexWrap: "wrap"
                      , marginTop: "40px"
                      , marginBottom: "40px"
                    }}>
                    <input type="button" style={{ width: "150px", color: "#1B335E", margin: "0 10px" }} value="キャンセル" class="buttonDefault modalClose graylBtn" onClick={() => navigate("/D0041ContactTop", { state: { dataList: contacts } })} />
                    <input type="button"
                      class="decision_button"
                      value="送信"
                      onClick={sendContact} />
                  </div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default D0042ContactConfirm;